<div class="max-w-[600px] my-64 mx-auto text-center">
  <h4>Houston, we have a problem!</h4>
  <h1>Error: Missing configuration</h1>
  <p class="m-24">
    We were not able to get the configuration for your user.<br />
    You might be able to solve the issue by trying to sign out and back in again:
  </p>
  <button
    class="flex flex-row items-center content-center gap-8 m-auto"
    nz-button
    nzType="primary"
    (click)="signOut()"
    data-test="sign-out-button"
  >
    <twaice-fe-svg-icon name="logout" source="tabler" size="16px" />
    Sign Out
  </button>
  <p class="m-24">
    If the issue persists please contact us at: <a href="mailto:support@twaice.com" target="_blank">support&#64;twaice.com</a>
  </p>
</div>
